import { render } from "./TransportDpd.vue?vue&type=template&id=38977aed"
import script from "./TransportDpd.vue?vue&type=script&lang=js"
export * from "./TransportDpd.vue?vue&type=script&lang=js"

import exportComponent from "/builds/ser-kso/new-claim-form/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__